<p id="home-title" class="text-center mb-5 mt-3">COVID-19 Dashboard</p>
<div class="container d-flex justify-content-center">
    <div class="card">
        <div class="card-body">
            <img src="assets/icons/brazil.svg" alt="Bandeira do Brasil">
            <p class="card-name my-auto">Brazil</p>
        </div>
        <a routerLink="/brazil" class="btn btn-primary btn-lg align-self-center">Selecionar</a>
    </div>

    <div class="card">
        <div class="card-body">
            <img src="assets/icons/world.svg" alt="Globo terrestre">
            <p class="card-name my-auto">Mundo</p>
        </div>
        <a routerLink="/world" class="btn btn-primary btn-lg align-self-center">Selecionar</a>
    </div>
</div>